import { formatNumber } from '../../common/helpers/formatNumber.helper';
import { Characters } from '../../common/helpers/unicode.helper';
import { Unit } from '../../common/models/ItemModel';

import { DemandNumber } from './DemandNumber';

interface DemandVolumeProps {
    volume: number;
}

export const DemandVolume = ({ volume }: DemandVolumeProps) => (
    <DemandNumber>
        {formatNumber({ number: volume, maximumFractionDigits: 0 })}
        {Characters.NO_BREAK_SPACE}
        {Unit.L}
    </DemandNumber>
);
